import { PlatformTrustBar } from '../PlatformShared'

export default function PricingTrustBar({ items }) {
    return <PlatformTrustBar items={items} />
}
